import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "testimonial-area ptb-100 position-relative z-1" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "masonrow" }
const _hoisted_4 = { class: "testimonial-single-item" }
const _hoisted_5 = { class: "ps-0 list-unstyled d-flex gap-1" }
const _hoisted_6 = { class: "pagination-area text-center mt-4" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "container" }, [
      _createElementVNode("div", { class: "section-title mw-860 m-auto text-center" }, [
        _createElementVNode("span", { class: "top-title" }, "آراء عملائنا"),
        _createElementVNode("h2", null, "لماذا يختارنا مشتركو الـ IPTV؟"),
        _createElementVNode("p", null, " لقد قمنا بجمع آراء عملائنا الذين استمتعوا بأفضل تجربة بث للقنوات العربية والأجنبية بجودة فائقة. ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedTestimonials, (testimonial, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("ul", _hoisted_5, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                  return _createElementVNode("li", { key: star }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "ri-star-fill" }, null, -1)
                  ]))])
                }), 64))
              ]),
              _createElementVNode("h3", null, _toDisplayString(testimonial.name), 1),
              _createElementVNode("p", null, _toDisplayString(testimonial.review), 1)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", {
          class: _normalizeClass(["next page-numbers", { disabled: _ctx.currentPage === 1 }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "ri-arrow-left-s-line" }, null, -1)
        ]))], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
          return (_openBlock(), _createElementBlock("span", {
            key: page,
            class: _normalizeClass(["page-numbers", { current: _ctx.currentPage === page }]),
            onClick: ($event: any) => (_ctx.goToPage(page))
          }, _toDisplayString(page), 11, _hoisted_7))
        }), 128)),
        _createElementVNode("span", {
          class: _normalizeClass(["next page-numbers", { disabled: _ctx.currentPage === _ctx.totalPages }]),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("i", { class: "ri-arrow-right-s-line" }, null, -1)
        ]))], 2)
      ])
    ])
  ]))
}